import React from 'react';

const SkeletonCard = ({ variant = 'actor' }) => {
  const imgClasses = variant === 'movie'
    ? 'w-9 h-[52px] rounded bg-[#e0d6cc] flex-shrink-0'
    : 'w-10 h-10 rounded-full bg-[#e0d6cc] flex-shrink-0';

  return (
    <div className="bg-white border-[3px] border-[#1a1a1a] rounded-xl p-3 flex items-center gap-3 shadow-[3px_3px_0_#1a1a1a] animate-pulse">
      <div className={imgClasses} />
      <div className="flex-1">
        <div className="h-3 bg-[#e0d6cc] rounded w-3/4 mb-1.5" />
        <div className="h-2 bg-[#e0d6cc] rounded w-1/2" />
      </div>
    </div>
  );
};

export default SkeletonCard;
